// extracted by css-extract-rspack-plugin
export default {"categoryCardImage":"CategoryCard-module__categoryCardImage__Fy9J6","categoryCard":"CategoryCard-module__categoryCard__xafJn"};